import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=0f21fea4&scoped=true"
import script from "./LoginPage.js?v=1?vue&type=script&lang=js&external"
export * from "./LoginPage.js?v=1?vue&type=script&lang=js&external"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=0f21fea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f21fea4",
  null
  
)

export default component.exports